module.exports = __webpack_public_path__ + "7a96ffced17c44f89c637660d513614f.png";